import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Field, formValueSelector, change } from 'redux-form'

import { getAirtableBases } from '../../../utils/api'
import WrappedInput from '../../Shared/Forms/WrappedInput'

export const API_KEY_PATTERN = /^key\w{10,16}/

export default function AirtableSetup({ form }) {
  const [options, setOptions] = useState([])
  const dispatch = useDispatch()
  const selector = formValueSelector(form)
  const apiKey = useSelector(state => selector(state, 'apiKey'))
  const baseId = useSelector(state => selector(state, 'baseId'))

  const key = apiKey && apiKey.match(API_KEY_PATTERN) ? apiKey : null

  const getBases = async () => {
    setOptions([])
    if (!key) return

    const { data: bases } = await getAirtableBases(apiKey)

    const options = bases.map(base => ({
      label: base.name,
      value: base.id,
    }))

    setOptions(options)
  }

  useEffect(() => {
    getBases().catch(err => {
      throw err
    })
  }, [key, setOptions])

  useEffect(() => {
    if (baseId) {
      const option = options.filter(opt => opt.value === baseId)[0]
      const name = option && option.label

      dispatch(change(form, 'name', name))
    }
  }, [baseId, dispatch])

  return (
    <div>
      <Field
        name="apiKey"
        component={WrappedInput}
        label="API Key"
        placeholder="key••••••••••••••"
        autoComplete="off"
        type="password"
      />
      {key && (
        <Field
          name="baseId"
          component={WrappedInput}
          label="Base"
          placeholder="Choose Base..."
          options={options}
        />
      )}
    </div>
  )
}
